import React from 'react';
import { connect } from 'react-redux';
import { selectHasSinglePinnedVariable } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { SizeAttributeDropdownList } from './SizeAttributeDropdownList';
import { SizeAttributeWindow } from './SizeAttributeWindow';

export const _SizeAttributeDropdownMobile = ({
    hasSinglePinnedVariable,
    hasPreview,
    renderPreview,
    variableIds
}: Props) => {
    if (hasSinglePinnedVariable) {
        return (
            <SizeAttributeDropdownList gap='xs' variableIds={variableIds} />
        );
    } else {
        return (
            <SizeAttributeWindow
                hasPreview={hasPreview} renderPreview={renderPreview}
                variableIds={variableIds} />
        );
    }
};

type Props = {
    renderPreview: () => JSX.Element;
    hasPreview: boolean;
    variableIds: string[];
    hasSinglePinnedVariable: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasSinglePinnedVariable: selectHasSinglePinnedVariable(state)
});

export const SizeAttributeDropdownMobile = connect(
    mapStateToProps
)(_SizeAttributeDropdownMobile);